import { Flex, IconButton, Text, useColorModeValue } from "@chakra-ui/react";
import { useAuth } from "providers/auth.provider";
import { RiLogoutBoxLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const footerColor = useColorModeValue("gray.100", "gray.900");
  const subTitleColor = useColorModeValue("gray.700", "gray.400");
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  }

  return (
    <Flex
      py="4"
      px="7"
      lineHeight="1.2"
      justifyContent="space-between"
      bgColor={footerColor}
      w="full"
    >
      <Flex alignItems="center">
        <Text fontSize="md" fontWeight="medium" maxW="190px" isTruncated>
          {user?.userToken.email}
        </Text>
      </Flex>
      <Flex
        justifyContent="center"
        alignItems="center"
        direction="column"
        color={subTitleColor}
      >
        <IconButton
          variant="ghost"
          size="md"
          fontSize="xl"
          _active={{
            bgColor: "rgba(0,0,0, 0.04)"
          }}
          _hover={{
            bgColor: "rgba(0,0,0, 0.04)"
          }}
          _selected={{
            bgColor: "rgba(0,0,0, 0.04)"
          }}
          aria-label={`Sair`}
          icon={<RiLogoutBoxLine />}
          onClick={handleLogout}
        />
      </Flex>
    </Flex>
  );
};
